import Cookies from 'js-cookie';

/**
    * @function getUser
    * @params
    * @description used to retrieve user information from a cookie and returns it as a JSON object
*/
export const getUser = () => {
    const userStr = Cookies.get('adpu');
    if (userStr) return JSON.parse(userStr);
    return null;
}

/**
    * @function getToken
    * @params
    * @description used to retrieve a token from a cookie named 'adpt'
*/
export const getToken = () => {
    const token = Cookies.get('adpt');
    if (token) return token;
    return null;
}

/**
    * @function getTheme
    * @params
    * @description used to retrieve the theme stored in a cookie named 'adtp'
*/
export const getTheme = () => {
    const theme = Cookies.get('adtp');
    if (theme) return theme;
    return null;
}

/**
    * @function updateUserSession
    * @params user
    * @description used to store user information in a cookie for 14 days
*/
export const updateUserSession = (user) => {
    Cookies.set('adpu', JSON.stringify(user), {
        expires: 10 / 1440
    });
}

/**
    * @function removeUserSession
    * @params
    * @description used to remove specific cookies related to user session
*/
export const removeUserSession = () => {
    Cookies.remove('adpt', {
        domain: `${process.env.REACT_APP_COOKIE_DOMAIN}`,
        path: '/'
    });
    Cookies.remove('adpu');
}